import { render, staticRenderFns } from "./TepPreliquidacionInternoIndex.vue?vue&type=template&id=5c2c31d9"
import script from "./TepPreliquidacionInternoIndex.vue?vue&type=script&lang=js"
export * from "./TepPreliquidacionInternoIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports